import { render, staticRenderFns } from "./OfferTasksTable.vue?vue&type=template&id=0a800ae4"
import script from "./OfferTasksTable.vue?vue&type=script&lang=js"
export * from "./OfferTasksTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports